import { requireTranslations } from '../../../common/translation';

export default requireTranslations((locale: string) => require(`./footer-links.${locale}.json`));
